import { Loader2, ShieldCheck, KeyRound, Smartphone } from "lucide-react";
import { TabsContent } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const SettingsPanel = ({
  me,
  curPw,
  setCurPw,
  newPw,
  setNewPw,
  savingPw,
  onChangePw,
  setup,
  code,
  setCode,
  onStartSetup,
  onEnable2fa,
  onDisable2fa,
}) => (
  <TabsContent value="settings" className="mt-6 space-y-6">
    <div className="bg-white border border-border rounded-2xl p-8 max-w-xl">
      <div className="flex items-center gap-2 text-ink">
        <KeyRound className="h-5 w-5 text-clay" />
        <h2 className="font-heading text-xl">Change password</h2>
      </div>
      <div className="mt-5 space-y-4">
        <div>
          <Label className="text-ink font-medium">Current password</Label>
          <Input type="password" data-testid="current-password-input" value={curPw} onChange={(e) => setCurPw(e.target.value)} className="mt-2 bg-white border-border focus-visible:ring-clay rounded-xl py-6" />
        </div>
        <div>
          <Label className="text-ink font-medium">New password</Label>
          <Input type="password" data-testid="new-password-input" value={newPw} onChange={(e) => setNewPw(e.target.value)} className="mt-2 bg-white border-border focus-visible:ring-clay rounded-xl py-6" />
        </div>
        <Button data-testid="change-password-button" onClick={onChangePw} disabled={savingPw || !curPw || !newPw} className="bg-clay hover:bg-clay-hover text-white rounded-lg px-7 py-5 font-medium">
          {savingPw ? <Loader2 className="h-4 w-4 animate-spin" /> : "Update password"}
        </Button>
      </div>
    </div>

    <div className="bg-white border border-border rounded-2xl p-8 max-w-xl">
      <div className="flex items-center gap-2 text-ink">
        <Smartphone className="h-5 w-5 text-clay" />
        <h2 className="font-heading text-xl">Two-factor authentication</h2>
      </div>
      {me?.totp_enabled ? (
        <div className="mt-4">
          <p className="inline-flex items-center gap-2 text-sm text-forest">
            <ShieldCheck className="h-4 w-4" /> 2FA is enabled.
          </p>
          <div className="mt-4 flex flex-col sm:flex-row gap-3 sm:items-end">
            <div className="flex-1">
              <Label className="text-ink font-medium">Authenticator code</Label>
              <Input inputMode="numeric" data-testid="twofa-code-input" value={code} onChange={(e) => setCode(e.target.value)} placeholder="123456" className="mt-2 bg-white border-border focus-visible:ring-clay rounded-xl py-6 tracking-widest" />
            </div>
            <Button variant="outline" data-testid="disable-2fa-button" onClick={onDisable2fa} className="border-border text-ink rounded-lg py-6">Disable 2FA</Button>
          </div>
        </div>
      ) : setup ? (
        <div className="mt-4">
          <p className="text-sm text-ink-muted">Add this secret to your authenticator app, then enter the 6-digit code to confirm.</p>
          <div className="mt-3 bg-sand border border-border rounded-lg p-3 font-mono text-sm break-all" data-testid="twofa-secret">{setup.secret}</div>
          <div className="mt-4 flex flex-col sm:flex-row gap-3 sm:items-end">
            <div className="flex-1">
              <Label className="text-ink font-medium">Code</Label>
              <Input inputMode="numeric" data-testid="twofa-code-input" value={code} onChange={(e) => setCode(e.target.value)} placeholder="123456" className="mt-2 bg-white border-border focus-visible:ring-clay rounded-xl py-6 tracking-widest" />
            </div>
            <Button data-testid="enable-2fa-button" onClick={onEnable2fa} className="bg-clay hover:bg-clay-hover text-white rounded-lg py-6">Enable 2FA</Button>
          </div>
        </div>
      ) : (
        <div className="mt-4">
          <p className="text-sm text-ink-muted">Add an extra layer of security with an authenticator app.</p>
          <Button data-testid="setup-2fa-button" onClick={onStartSetup} className="mt-4 bg-clay hover:bg-clay-hover text-white rounded-lg px-7 py-5 font-medium">Set up 2FA</Button>
        </div>
      )}
    </div>
  </TabsContent>
);
